import $ from 'jquery';

const getQuestionBlock = (questionCode) => {
  return $('[data-question-code="' + questionCode + '"]');
};

export default getQuestionBlock;
